import React, { ElementType, ReactNode } from "react";
import { Blockquote } from "../Blockquote";
import { Box, HStack } from "@chakra-ui/react";
import { TaskContent } from "./TaskContent";

type TaskWrapperProps = {
  taskId?: string;
  title: string;
  icon: ElementType;
  isComplete?: boolean;
  children: ReactNode;
};

export const TaskWrapper = ({
  title,
  icon,
  taskId,
  isComplete,
  children,
  ...props
}: TaskWrapperProps) => (
  <Blockquote
    id={taskId}
    borderColor={isComplete ? "success" : "primary"}
    {...props}
  >
    <HStack
      mb="1"
      fontWeight="semibold"
      color={isComplete ? "success" : "primary"}
    >
      <Box as={icon} flexShrink={0} />
      <span>
        <TaskContent>{title}</TaskContent>
      </span>
    </HStack>
    {children}
  </Blockquote>
);
